import { cx, styled } from "simplydo/react/styled";

import type { CheckboxSlotProps } from "./Checkbox.types";

const ChildrenEl = styled.div`
  margin-top: 1rem;

  :last-child {
    margin-bottom: 0;
  }

  :first-child {
    margin-top: 0;
  }
`;

const CheckboxChildrenComponent = (props: CheckboxSlotProps) => {
  const { children, className, style } = props;

  return (
    <ChildrenEl className={cx(className)} style={style}>
      {children}
    </ChildrenEl>
  );
};

export const CheckboxChildren = styled(CheckboxChildrenComponent)``;
CheckboxChildren.displayName = "CheckboxChildren";
